import {useRef, useState, useEffect} from 'react'
import {useLocation} from 'react-router-dom'

import Normal from './ui/Normal'
import NormalBreak from './ui/NormalBreak'
import usePreviewGameLogic from './usePreviewGameLogic'

const TimerPreview = () => {
	const location = useLocation()
	const [eventData, setEventData] = useState(location.state?.eventData || null)
	const wrapperRef = useRef(null)

	// Load from localStorage if not in location state
	useEffect(() => {
		if (!eventData) {
			const storedData = localStorage.getItem('previewEventData')
			if (storedData) {
				try {
					setEventData(JSON.parse(storedData))
				} catch (e) {
					console.error('Failed to parse stored event data', e)
				}
			}
		}
	}, [eventData])

	// Use hook to calculate accurate display data
	const {formattedGameData: timeData, infoData} = usePreviewGameLogic(eventData)

	// Derived data for display
	// Note: URL.createObjectURL might fail if eventData.logo_url is not a File object (e.g. from localStorage stringify)
	// For preview from localStorage, we might need to handle images differently or accept they won't show.
	// If it's a string (URL), use it. If it's a File object (passed via state), create URL.
	let logoImg = null
	if (eventData?.logo_url) {
		if (eventData.logo_url instanceof File) {
			logoImg = URL.createObjectURL(eventData.logo_url)
		} else if (typeof eventData.logo_url === 'string') {
			// If it's a data URL or http URL
			logoImg = eventData.logo_url
		} else if (
			typeof eventData.logo_url === 'object' &&
			eventData.logo_url.preview
		) {
			// Some uploaders add a preview property
			logoImg = eventData.logo_url.preview
		}
	}

	// Default mock prize data if not yet processed
	const prizeData = {
		total: eventData?.prize_total,
		list: eventData?.prize_list,
	}

	// Navigation block mock
	const enableNavigationBlock = false
	const setEnableNavigationBlock = () => {}
	const navigateWithConfirm = (path) => {}

	if (!eventData)
		return (
			<div
				style={{
					color: 'white',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					height: '100vh',
				}}
			>
				Loading Event Data...
			</div>
		)

	// Wait for game logic to process
	if (!timeData)
		return (
			<div
				style={{
					color: 'white',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					height: '100vh',
				}}
			>
				Processing Preview...
			</div>
		)

	const isBreak = timeData.level === 'break'

	return (
		<div style={{position: 'relative'}}>
			{isBreak ? (
				<NormalBreak
					countDown={timeData.time}
					timeData={timeData}
					infoData={infoData}
					logoImg={logoImg}
					eventName={eventData.name}
					eventData={eventData}
					navigationBlock={enableNavigationBlock}
					setNavigationBlock={setEnableNavigationBlock}
					navigateWithConfirm={navigateWithConfirm}
				/>
			) : (
				<Normal
					elapsedTime={0}
					elapsedTimeDisplay={timeData.total_time || '00:00:00'}
					countDown={timeData.time}
					nextBreak={timeData.next_break_time}
					regClose={timeData.reg_end_time}
					timeData={timeData}
					prizeData={prizeData}
					infoData={infoData}
					logoImg={logoImg}
					eventName={eventData.name}
					eventData={eventData}
					wrapperRef={wrapperRef}
					navigationBlock={enableNavigationBlock}
					setNavigationBlock={setEnableNavigationBlock}
					navigateWithConfirm={navigateWithConfirm}
					// Pass prize_list as the source for the slideshow if prize_editor is empty or malformed
					prize_editor={
						Array.isArray(eventData.prize_list) &&
						Array.isArray(eventData.prize_list[0])
							? eventData.prize_list.map(([rank, prize]) => ({rank, prize}))
							: eventData.prize_list || eventData.prize_editor
					}
				/>
			)}
		</div>
	)
}

export default TimerPreview
